export const cilLockUnlocked = ["24 24","<path d='M18 9.375v-2.625c-0-3.314-2.686-6-6-6-1.635 0-3.118 0.654-4.2 1.715l0.001-0.001 1.050 1.071c0.811-0.795 1.923-1.286 3.149-1.286 2.485 0 4.5 2.015 4.5 4.5v0 2.625h-12.375v6c0 4.342 3.533 7.875 7.875 7.875s7.875-3.533 7.875-7.875v-6zM18.375 15.375c0 3.515-2.86 6.375-6.375 6.375s-6.375-2.86-6.375-6.375v-4.5h12.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-lock-unlocked.js
// module id = null
// module chunks = 